import store from '@ps/store'
import _ from 'lodash'
import {
  executeAction,
  getAddPairDataAction,
  getRemovePairDataAction,
  getUpdatePairsDataAction,
  getApplyToOtherAction,
  getUpdateAreasDataAction,
  getUpdateFreeDrawLineStyleAction,
} from '@ps/workbench/undo-redo'
import { scripts } from '@ps/bridge/qc/scripts'
export default {
  addPairData({ state }) {
    const pairsData = _.cloneDeep(store.state.workspace.game.drawLine.pairsData)
    executeAction({
      action: getAddPairDataAction({
        newValue: {},
        oldValue: pairsData,
      }),
    })
  },
  removePairData({ state }, { uuid }) {
    const pairsData = _.cloneDeep(store.state.workspace.game.drawLine.pairsData)
    const cloneAst = _.cloneDeep(store.state.workspace.game.visualProgram.ast)
    executeAction({
      action: getRemovePairDataAction({
        newValue: { uuid },
        oldValue: {
          pair: pairsData,
          ast: cloneAst,
        },
      }),
    })
  },
  updatePairsData({ state }, { pairData }) {
    const pairsData = _.cloneDeep(store.state.workspace.game.drawLine.pairsData)
    executeAction({
      action: getUpdatePairsDataAction({
        newValue: {
          pairData,
        },
        oldValue: pairsData,
      }),
    })
  },
  applyLineStyleToAll({ state }, { name }) {
    const areasData = _.cloneDeep(store.state.workspace.game.drawLine.areasData)
    executeAction({
      action: getApplyToOtherAction({
        newValue: {
          name,
        },
        oldValue: areasData,
      }),
    })
  },
  updateAreasData({ state }, { areaData }) {
    const areasData = _.cloneDeep(store.state.workspace.game.drawLine.areasData)
    executeAction({
      action: getUpdateAreasDataAction({
        newValue: {
          areaData,
        },
        oldValue: areasData,
      }),
    })
  },
  updateFreeDrawLineStyle({ state }, { node, style }) {
    const dlc = node.getScript(scripts.drawLine.name)
    const rgb = dlc.brushColor.rgb
    const lineColor = `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 1)`
    const lineSize = dlc.brushSize
    executeAction({
      action: getUpdateFreeDrawLineStyleAction({
        node,
        newValue: {
          style,
        },
        oldValue: {
          style: {
            lineColor,
            lineSize,
          },
        },
      }),
    })
  },
}
